import { SpaceScanData } from "../../../passapp-sdk/types/spaceTypes";

// El resultado del scan viaja del scanner a la pantalla de resultado sin
// exponer datos de la persona en la URL.
let lastScan: SpaceScanData | null = null;

export const setLastSpaceScan = (scan: SpaceScanData) => {
  lastScan = scan;
};

export const getLastSpaceScan = () => lastScan;

export const clearLastSpaceScan = () => {
  lastScan = null;
};
